import { Box, Stack, Typography } from "@mui/material"
import palette from "theme/palette"
import { PdfAuthorNote } from "./pdf-author-note"

export function PdfScheduleMetadataSection({ originalUnitOfMeasure, draftUnitOfMeasure, note, changed }) {
    return (
        <Box component="tbody" sx={{ pageBreakAfter: "auto", breakAfter: "auto" }}>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography sx={{ fontWeight: 700, fontSize: "11px", color: palette.light.text.primary }}>
                            Schedule details
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "10px",
                                color: changed ? palette.light.primary.main : palette.light.text.secondary,
                            }}
                        >
                            {changed ? "Changes Highlighted" : "No Changes"}
                        </Typography>
                    </Stack>
                </Box>
            </Box>
            <Box component="tr">
                {renderMetadataCell({
                    label: "Unit of measure",
                    sideLabel: "Previous",
                    value: originalUnitOfMeasure,
                })}
                {renderMetadataCell({
                    label: "Unit of measure",
                    sideLabel: "Amendments",
                    value: draftUnitOfMeasure,
                    note,
                    emphasis: true,
                })}
            </Box>
        </Box>
    )
}

function renderMetadataCell({ label, sideLabel, value, note, emphasis = false }) {
    return (
        <Box
            component="td"
            sx={{
                width: "50%",
                p: "12px 20px",
                verticalAlign: "top",
                borderBottom: `1px solid ${palette.light.divider}`,
            }}
        >
            <Typography sx={{ fontSize: "9px", color: palette.light.text.secondary, mb: "4px" }}>{label}</Typography>
            <Typography
                sx={{
                    fontSize: "11px",
                    color: emphasis ? palette.light.text.primary : palette.light.text.secondary,
                    fontWeight: emphasis ? 700 : 400,
                }}
            >
                {sideLabel}: {value || "—"}
            </Typography>
            <PdfAuthorNote note={note} />
        </Box>
    )
}

const sectionHeadingCellSx = {
    p: "10px 20px",
    backgroundColor: palette.light.background.neutral,
    borderBottom: `1px solid ${palette.light.divider}`,
}
